<script>
	import { onMount } from 'svelte';
	import '../app.postcss';
	import { page } from '$app/stores';
	import { Util } from '$lib/utils';

	const pixel_id = '1634433049972990';

	onMount(()=>{
		const coupon = $page.url.searchParams.get('coupon')
		console.log('promo code',coupon)
        if(coupon != null){
            sessionStorage.setItem('coupon',coupon)
        }

		initialisePixelTracking();
		Util.initialiseGoogleTracking();
		console.log(Util.verifyToken());
		
	})
	
	function initialisePixelTracking(){
		!(function (f, b, e, v, n, t, s) {
			if (f.fbq) return;
			n = f.fbq = function () {
				n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
			};
			if (!f._fbq) f._fbq = n;
			n.push = n;
			n.loaded = !0;
			n.version = "2.0";
			n.queue = [];
			t = b.createElement(e);
			t.async = !0;
			t.src = "https://connect.facebook.net/en_US/fbevents.js";
			s = b.getElementsByTagName(e)[0];
			s.parentNode.insertBefore(t, s);
		})(window, document, "script");

		fbq("init", pixel_id); // Replace with your Meta Pixel ID
		fbq("track", "PageView");
	}
</script>

<slot />
